export enum Routes {
  Main = '/',
  Login = '/login',
  Logout = '/logout',
  OauthCallback = '/oauth/callback',
  Dashboard = '/dashboard',
  SignRequests = '/signed-documents',
  SignRequestTraceLogs = '/signed-documents/:id/trace-logs',
  SignRequest = '/signed-documents/:signRequestId/request/:requestId',
  ScanRequests = '/scanned-documents',
  ScanRequest = '/scanned-documents/:scanRequestId/request/:requestId',
  ScanRequestTraceLogs = '/scanned-documents/:id/trace-logs',
  Customers = '/customers',
  CustomerTraceLogs = '/customers/:id/trace-logs',
  ClientUsers = '/users',
  ClientUserTraceLogs = '/users/:id/trace-logs',
  ClientGroups = '/groups',
  UserTraceLogs = '/user/trace-logs',
  UserDetails = '/user',
}
